import { NEWBUILDING_CONSULTANT_MESSAGE_BUTTON } from '../../constants/experiments';
import { IApplicationState } from '../../types/redux';
import { isAbUseExperimentActive } from '../../utils/experiments';
import { getBuilderChatEnabled } from '../builderChat';

export function isConsultantChatOpenedSelector(state: IApplicationState) {
  return state.consultantChat.isOpen;
}

export const selectWebimAccountName = (state: IApplicationState) => state.settings.webimAccountName;

export const selectWebimHost = (state: IApplicationState) => state.settings.webimHost;

export const selectWebimLocation = (state: IApplicationState) => state.settings.webimLocation;

// TODO: Удалить в CD-225148.
export const selectConsultantMessageButtonAvailable = (state: IApplicationState): boolean => {
  const { settings, experiments } = state;

  return (
    settings.isConsultantMessageButtonEnabled &&
    Boolean(settings.webimAccountName) &&
    !getBuilderChatEnabled(state) &&
    isAbUseExperimentActive(experiments, NEWBUILDING_CONSULTANT_MESSAGE_BUTTON, 'B')
  );
};
